// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd954327","239":"e39fb35b","312":"3c59898f","455":"3bef4cb2","551":"8912905c","828":"6cc522b3"}[chunkId] + ".chunk.js";
};